import { processURLAddress } from '@vue-storefront/core/helpers'

export function buildApiUrl (baseUrl, params) {
  let url = processURLAddress(baseUrl)
  Object.keys(params).forEach(key => {
    url = `${url}${url.includes('?') ? '&' : '?'}${key}=${params[key]}` // K2-3138: follow the URL's own query
  })

  return url
}
